module.exports = __webpack_public_path__ + "static/media/8000.64579ff9.jpg";